const GUEST_KEY = 'ledscroller_guest_access_code';
const ORDER_KEY = 'ledscroller_last_order_id';
const AUTH_KEY = 'ledscroller_auth_token';

export const getGuestAccessCode = () => {
  try {
    return localStorage.getItem(GUEST_KEY) || '';
  } catch (e) {
    return '';
  }
};

export const setGuestAccessCode = (code) => {
  try {
    if (code) {
      localStorage.setItem(GUEST_KEY, code);
    }
  } catch (e) {
    // ignore
  }
};

export const getLastOrderId = () => {
  try {
    return localStorage.getItem(ORDER_KEY) || '';
  } catch (e) {
    return '';
  }
};

export const setLastOrderId = (orderId) => {
  try {
    if (orderId) {
      localStorage.setItem(ORDER_KEY, orderId);
    }
  } catch (e) {
    // ignore
  }
};

export const getAuthToken = () => {
  try {
    return localStorage.getItem(AUTH_KEY) || '';
  } catch (e) {
    return '';
  }
};

export const setAuthToken = (token) => {
  try {
    if (token) {
      localStorage.setItem(AUTH_KEY, token);
    } else {
      localStorage.removeItem(AUTH_KEY);
    }
  } catch (e) {
    // ignore
  }
};

export const clearAuthToken = () => setAuthToken('');
